import { defineNuxtPlugin } from 'nuxt/app';
import type { NuxtApp } from 'nuxt/app';

import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';

export default defineNuxtPlugin((nuxtApp: NuxtApp) => {
  nuxtApp.vueApp.component('Carousel', Carousel);
  nuxtApp.vueApp.component('Slide', Slide);
});
